/* ForeFrontier: the Kit Room (trip kits page and home page hero) */
(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-kitroom]');
  if (!roots.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hasWebGL() {
    try { var c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'))); } catch (e) { return false; }
  }
  if (!hasWebGL()) { roots.forEach(function (r) { r.classList.add('is-fallback'); }); return; }

  var waiting = [], loadingThree = false;
  function loadThree(src, cb) {
    if (window.THREE) return cb();
    waiting.push(cb);
    if (loadingThree) return;
    loadingThree = true;
    var s = document.createElement('script');
    s.src = src; s.async = true;
    s.onload = function () { waiting.forEach(function (f) { f(); }); waiting = []; };
    s.onerror = function () { roots.forEach(function (r) { r.classList.add('is-fallback'); }); };
    document.head.appendChild(s);
  }

  roots.forEach(function (root) {
    var started = false;
    function start() { if (started) return; started = true; loadThree(root.getAttribute('data-three'), function () { init(root); }); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { start(); io.disconnect(); } }, { rootMargin: '300px' });
      io.observe(root);
    } else start();
  });

  function init(root) {
    var T = window.THREE;
    var stage = root.querySelector('[data-kitroom-stage]');
    var canvas = root.querySelector('[data-kitroom-canvas]');
    var loading = root.querySelector('[data-kitroom-loading]');
    var mode = root.getAttribute('data-kitroom-mode') || 'full';
    var KITS = {
      stone: { kit: '#F3F2EE', thread: '#1B2336' }, /* the light kit: white cap and polo */
      navy: { kit: '#222C44', thread: '#C9A06A' }
    };
    function lin(h) { return new T.Color(h).convertSRGBToLinear(); }
    var state = { colour: 'stone', place: 'Algarve', trip: 'Tour 2027', coords: '37.08\u00B0 N \u00B7 8.12\u00B0 W' };

    /* renderer, scene, camera */
    var renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.outputEncoding = T.sRGBEncoding;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = T.PCFSoftShadowMap;

    var scene = new T.Scene();
    var bg = new T.Color('#1B2336');
    scene.fog = new T.Fog(bg, 7.5, 19);
    var camera = new T.PerspectiveCamera(32, 16 / 9, 0.05, 80);

    scene.add(new T.HemisphereLight(0xE4E9F2, 0x243049, 0.75));
    var sun = new T.DirectionalLight(0xFFF1DC, 1.35);
    sun.position.set(4.5, 8, 6);
    sun.castShadow = true;
    sun.shadow.mapSize.set(1024, 1024);
    sun.shadow.camera.left = -4; sun.shadow.camera.right = 4; sun.shadow.camera.top = 4; sun.shadow.camera.bottom = -4;
    sun.shadow.camera.near = 1; sun.shadow.camera.far = 20;
    sun.shadow.bias = -0.0005; sun.shadow.normalBias = 0.02; sun.shadow.radius = 4;
    scene.add(sun);
    var rim = new T.DirectionalLight(0xA9BCE0, 0.55);
    rim.position.set(-4, 5, -6);
    scene.add(rim);

    /* ground: a mown tee box fading into the night */
    function stripeTexture() {
      var c = document.createElement('canvas'); c.width = 512; c.height = 512;
      var g = c.getContext('2d');
      for (var i = 0; i < 8; i++) { g.fillStyle = i % 2 ? '#3C5639' : '#44603F'; g.fillRect(i * 64, 0, 64, 512); }
      for (var n = 0; n < 5000; n++) { g.fillStyle = 'rgba(0,0,0,' + (Math.random() * 0.06) + ')'; g.fillRect(Math.random() * 512, Math.random() * 512, 2, 2); }
      var t = new T.CanvasTexture(c); t.wrapS = t.wrapT = T.RepeatWrapping; t.repeat.set(5.5, 5.5); t.encoding = T.sRGBEncoding;
      return t;
    }
        var tee = new T.Mesh(new T.CircleGeometry(16, 96), new T.MeshStandardMaterial({ map: stripeTexture(), roughness: 0.95 }));
    tee.rotation.x = -Math.PI / 2; tee.receiveShadow = true; scene.add(tee);
    var markerMat = new T.MeshStandardMaterial({ color: lin('#D9CFBF'), roughness: 0.6 });
    if (mode !== 'hero') [-2.3, 2.3].forEach(function (x) {
      var m = new T.Mesh(new T.SphereGeometry(0.09, 20, 14), markerMat); m.position.set(x, 0.07, 1.6); m.castShadow = true; scene.add(m);
    });
    /* distant flag */
    var pole = new T.Mesh(new T.CylinderGeometry(0.02, 0.02, 2.4, 8), new T.MeshStandardMaterial({ color: lin('#E6E1D6') }));
    pole.position.set(3.6, 1.2, -13); scene.add(pole);
    var flagShape = new T.Shape(); flagShape.moveTo(0, 0); flagShape.lineTo(0.75, -0.22); flagShape.lineTo(0, -0.44);
    var flag = new T.Mesh(new T.ShapeGeometry(flagShape), new T.MeshStandardMaterial({ color: lin('#C9A06A'), side: T.DoubleSide }));
    flag.position.set(3.62, 2.4, -13); scene.add(flag);

    /* crest textures */
    function fitFont(g, text, weight, family, maxW, start) {
      var size = start;
      do { g.font = weight + ' ' + size + 'px ' + family; size -= 2; } while (g.measureText(text).width > maxW && size > 10);
      return size + 2;
    }
    function spaced(g, text, x, y, spacing) {
      var total = 0, i, w = [];
      for (i = 0; i < text.length; i++) { w.push(g.measureText(text[i]).width); total += w[i] + (i < text.length - 1 ? spacing : 0); }
      var cx = x - total / 2;
      for (i = 0; i < text.length; i++) { g.fillText(text[i], cx + w[i] / 2, y); cx += w[i] + spacing; }
    }
    function flagMark(g, x, y, s, col) {
      g.fillStyle = col;
      g.fillRect(x - 7 * s, y, 3 * s, 34 * s);
      g.beginPath(); g.moveTo(x - 4 * s, y); g.lineTo(x + 14 * s, y + 6 * s); g.lineTo(x - 4 * s, y + 12 * s); g.closePath(); g.fill();
      g.fillRect(x - 4 * s, y + 17 * s, 9 * s, 3 * s);
      g.fillRect(x - 7 * s, y + 31 * s, 14 * s, 3 * s);
    }
    function stitch(g, col) { g.fillStyle = col; g.shadowColor = 'rgba(0,0,0,0.35)'; g.shadowBlur = 3; g.shadowOffsetY = 2; }
    var SERIF = '"Libre Caslon Text", Georgia, serif', SANS = '"Instrument Sans", Arial, sans-serif';

    var capCanvas = document.createElement('canvas'); capCanvas.width = 1024; capCanvas.height = 440;
    var chestCanvas = document.createElement('canvas'); chestCanvas.width = 512; chestCanvas.height = 512;
    var capTex = new T.CanvasTexture(capCanvas); capTex.encoding = T.sRGBEncoding; capTex.anisotropy = 8;
    var chestTex = new T.CanvasTexture(chestCanvas); chestTex.encoding = T.sRGBEncoding; chestTex.anisotropy = 8;

    function drawCrests() {
      var col = KITS[state.colour].thread;
      var g = capCanvas.getContext('2d');
      g.clearRect(0, 0, 1024, 440);
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      stitch(g, col);
      flagMark(g, 512, 8, 1.7, col);
      var place = state.place.toUpperCase();
      fitFont(g, place, '700', SERIF, 900, 170);
      g.fillText(place, 512, 222);
      g.fillRect(512 - 170, 246, 340, 8);
      g.font = '600 58px ' + SANS; spaced(g, state.trip.toUpperCase(), 512, 322, 12);
      g.font = '500 40px ' + SANS; spaced(g, state.coords, 512, 392, 4);
      capTex.needsUpdate = true;

      var h = chestCanvas.getContext('2d');
      h.clearRect(0, 0, 512, 512);
      h.textAlign = 'center';
      stitch(h, col);
      flagMark(h, 256, 70, 3.2, col);
      var small = state.place.toUpperCase();
      fitFont(h, small, '700', SERIF, 470, 92);
      h.fillText(small, 256, 290);
      h.fillRect(256 - 60, 312, 120, 5);
      h.font = '600 40px ' + SANS; spaced(h, state.trip.toUpperCase(), 256, 370, 6);
      if (state.coords) { h.font = '600 30px ' + SANS; spaced(h, state.coords, 256, 430, 3); }
      chestTex.needsUpdate = true;
    }

    /* golfers */
    var SKIN = ['#E3BC9C', '#B98262', '#8A5A3E', '#F0CFB5'];
    var TROUSERS = ['#2C313C', '#8A8472', '#1D2539', '#5F6571'];
    var kitMats = [];
    function mat(color, rough) { return new T.MeshStandardMaterial({ color: lin(color), roughness: rough == null ? 0.8 : rough }); }
    function part(geo, m, parent, x, y, z) {
      var mesh = new T.Mesh(geo, m); mesh.position.set(x || 0, y || 0, z || 0);
      mesh.castShadow = true; mesh.receiveShadow = true; parent.add(mesh); return mesh;
    }
    function limbGeo(rt, rb, len) { var g = new T.CylinderGeometry(rt, rb, len, 16); g.translate(0, -len / 2, 0); return g; }

    function makeGolfer(i, pose) {
      var skin = mat(SKIN[i], 0.6), trousers = mat(TROUSERS[i], 0.9), shoe = mat('#EFECE6', 0.5);
      var kit = mat(KITS.stone.kit, 0.88); kitMats.push(kit);
      var gr = new T.Group();

      /* legs and shoes */
      [-1, 1].forEach(function (side) {
        var hip = new T.Group(); hip.position.set(side * 0.1, 0.9, 0); hip.rotation.z = side * 0.035; gr.add(hip);
        part(limbGeo(0.088, 0.066, 0.84), trousers, hip);
        var s = part(new T.SphereGeometry(0.075, 16, 12), shoe, hip, 0, -0.86, 0.05); s.scale.set(1.05, 0.62, 1.75);
      });
      var pelvis = part(new T.CylinderGeometry(0.168, 0.176, 0.16, 24), trousers, gr, 0, 0.9, 0); pelvis.scale.z = 0.7;

      /* polo torso */
      var prof = [[0.182, 0], [0.198, 0.08], [0.21, 0.2], [0.228, 0.33], [0.232, 0.42], [0.205, 0.5], [0.13, 0.555], [0.05, 0.57]].map(function (p) { return new T.Vector2(p[0], p[1]); });
      var torso = part(new T.LatheGeometry(prof, 36), kit, gr, 0, 0.9, 0); torso.scale.z = 0.7;
      var collar = part(new T.TorusGeometry(0.068, 0.024, 10, 28, Math.PI * 1.6), kit, gr, 0, 1.458, 0);
      collar.rotation.x = Math.PI / 2; collar.rotation.z = Math.PI * 0.72;
      var placket = part(new T.BoxGeometry(0.03, 0.09, 0.004), kit, gr, 0, 1.405, 0.14); placket.rotation.x = -0.28;
      [1.43, 1.39].forEach(function (y) { part(new T.SphereGeometry(0.006, 8, 6), mat('#E9E5DC', 0.4), gr, 0, y, 0.145); });

      /* chest roundel */
      var chest = new T.Mesh(new T.PlaneGeometry(0.085, 0.085), new T.MeshStandardMaterial({ map: chestTex, transparent: true, roughness: 0.7, polygonOffset: true, polygonOffsetFactor: -2 }));
      chest.position.set(0.098, 1.33, 0.158); chest.rotation.y = 0.38; gr.add(chest);

      /* neck, head */
      part(new T.CylinderGeometry(0.052, 0.056, 0.1, 16), skin, gr, 0, 1.5, 0);
      var head = part(new T.SphereGeometry(0.112, 28, 20), skin, gr, 0, 1.655, 0.005); head.scale.set(0.94, 1.08, 1);

      /* cap */
      var capY = 1.69;
      var crown = part(new T.SphereGeometry(0.124, 32, 18, 0, Math.PI * 2, 0, Math.PI / 2 + 0.26), kit, gr, 0, capY, 0);
      crown.scale.set(1, 0.95, 1.08);
      part(new T.SphereGeometry(0.013, 10, 8), kit, gr, 0, capY + 0.118, 0);
      var brim = part(new T.CylinderGeometry(0.116, 0.116, 0.008, 32, 1, false, -Math.PI / 2, Math.PI), kit, gr, 0, capY - 0.013, 0.05);
      brim.scale.set(0.9, 1, 1.7); brim.rotation.x = 0.22;
      var crestGeo = new T.SphereGeometry(0.1256, 48, 24, Math.PI / 2 - 0.66, 1.32, 0.9, 0.58);
      var crest = new T.Mesh(crestGeo, new T.MeshStandardMaterial({ map: capTex, transparent: true, roughness: 0.65, polygonOffset: true, polygonOffsetFactor: -2 }));
      crest.position.set(0, capY, 0); crest.scale.set(1, 0.95, 1.08); gr.add(crest);

      /* arms: shoulder pivot, elbow pivot */
      var arms = {};
      [-1, 1].forEach(function (side) {
        var sh = new T.Group(); sh.position.set(side * 0.225, 1.4, 0); gr.add(sh);
        part(new T.SphereGeometry(0.07, 16, 12), kit, sh);
        part(limbGeo(0.068, 0.064, 0.19), kit, sh, 0, 0.01, 0);
        part(limbGeo(0.056, 0.05, 0.14), skin, sh, 0, -0.17, 0);
        var el = new T.Group(); el.position.y = -0.3; sh.add(el);
        part(new T.SphereGeometry(0.05, 12, 10), skin, el);
        part(limbGeo(0.048, 0.04, 0.26), skin, el);
        var hand = part(new T.SphereGeometry(0.046, 12, 10), skin, el, 0, -0.29, 0); hand.scale.set(0.8, 1.15, 1);
        arms[side] = { sh: sh, el: el };
      });
      function setArm(side, sx, sz, ex, ez) { var a = arms[side]; a.sh.rotation.set(sx, 0, sz); a.el.rotation.set(ex, 0, ez || 0); }

      /* poses. side +1 is the golfer's left */
      if (pose === 'club') {
        setArm(1, -0.62, -0.26, -0.55); setArm(-1, -0.62, 0.26, -0.55);
        var club = new T.Group(); club.position.set(0, 0, 0.36); gr.add(club);
        part(new T.CylinderGeometry(0.019, 0.016, 0.22, 12), mat('#151A24', 0.7), club, 0, 0.82, 0);
        part(new T.CylinderGeometry(0.009, 0.006, 0.84, 8), mat('#B9BEC6', 0.3), club, 0, 0.38, 0);
        var hd = part(new T.SphereGeometry(0.075, 20, 14), mat('#11151D', 0.35), club, 0.02, 0.045, 0.02); hd.scale.set(1.25, 0.55, 1);
      } else if (pose === 'hip') {
        setArm(1, 0.05, 0.6, 0, -1.55); setArm(-1, 0.02, -0.12, -0.12);
      } else if (pose === 'back') {
        setArm(1, 0.28, -0.08, 0.95); setArm(-1, 0.28, 0.08, 0.95);
      } else {
        setArm(1, 0.02, 0.13, -0.18); setArm(-1, 0.04, -0.12, -0.12);
      }
      gr.userData = { torso: torso, arms: arms, phase: i * 1.7 };
      return gr;
    }

    var golfers = [];
    var layout = [
      { x: -1.38, z: 0.05, ry: 0.32, pose: 'back' },
      { x: -0.45, z: 0.42, ry: 0.1, pose: 'club' },
      { x: 0.48, z: 0.38, ry: -0.08, pose: 'relaxed' },
      { x: 1.4, z: 0.0, ry: -0.3, pose: 'hip' }
    ];
    layout.forEach(function (l, i) {
      var g = makeGolfer(i, l.pose); g.position.set(l.x, 0, l.z); g.rotation.y = l.ry; scene.add(g); golfers.push(g);
    });

    function applyColour() {
      var c = lin(KITS[state.colour].kit);
      kitMats.forEach(function (m) { m.color.copy(c); });
      drawCrests();
    }

    /* camera views */
    var VIEWS = {
      fourball: function () {
        var w = stage.clientWidth, narrow = w < 640;
        if (mode === 'hero' && w >= 900) return { target: new T.Vector3(-1.95, 1.05, 0.2), dist: 8.9, elev: 0.1, az: 0.06 };
        if (mode === 'hero') return { target: new T.Vector3(0, narrow ? 0.98 : 0.95, 0.2), dist: narrow ? 5.7 : 6.8, elev: 0.1, az: 0 };
        return { target: new T.Vector3(0, narrow ? 0.55 : 0.98, 0.2), dist: narrow ? 6.9 : 6.3, elev: 0.13, az: 0 };
      },
      cap: function () { var g = golfers[1]; var p = g.position.clone(); p.y = 1.7; if (mode === 'hero' && stage.clientWidth >= 900) p.x -= 0.34; return { target: p, dist: 0.9, elev: 0.06, az: g.rotation.y }; },
      polo: function () { var g = golfers[2]; var p = g.position.clone(); p.y = 1.3; return { target: p, dist: 1.25, elev: 0.1, az: g.rotation.y + 0.18 }; }
    };
    var view = 'fourball';
    var cam = VIEWS.fourball(); var goal = VIEWS.fourball();
    var drag = 0, lastInteract = -1e9;

    function setView(name) {
      view = name; goal = VIEWS[name](); drag = 0; lastInteract = performance.now();
      root.querySelectorAll('[data-kitroom-view]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-kitroom-view') === name)); });
    }
    root.querySelectorAll('[data-kitroom-view]').forEach(function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-kitroom-view')); }); });

    /* drag to turn */
    var dragging = false, lastX = 0;
    canvas.addEventListener('pointerdown', function (e) { dragging = true; lastX = e.clientX; canvas.setPointerCapture(e.pointerId); lastInteract = performance.now(); });
    canvas.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      drag = Math.max(-1.15, Math.min(1.15, drag + (e.clientX - lastX) * -0.006)); lastX = e.clientX; lastInteract = performance.now();
    });
    function endDrag() { dragging = false; }
    canvas.addEventListener('pointerup', endDrag); canvas.addEventListener('pointercancel', endDrag);

    function syncColourButtons() {
      root.querySelectorAll('[data-kitroom-colour]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-kitroom-colour') === state.colour)); });
    }
    var caption = root.querySelector('[data-kitroom-caption]');
    function showCaption() {
      if (!caption) return;
      caption.textContent = state.place + '   ' + state.trip + (state.coords ? '   ' + state.coords : '');
    }
    function refresh() { syncColourButtons(); applyColour(); showCaption(); }

    /* trip kits page: follow the order form */
    function readForm() {
      var p = document.querySelector('.trip [data-crest-place]');
      var t = document.querySelector('.trip [data-crest-trip]');
      var c = document.querySelector('.trip [data-crest-coords]');
      if (p) state.place = p.textContent.trim() || state.place;
      if (t) state.trip = t.textContent.trim() || state.trip;
      if (c) state.coords = c.classList.contains('is-pending') ? '' : c.textContent.trim();
      var sel = document.querySelector('[data-crest-input="colour"]');
      if (sel) state.colour = /^navy/i.test(sel.value) ? 'navy' : 'stone';
      refresh();
    }

    /* home page: cycle through real trips until someone types their own */
    var CYCLE = [
      ['Algarve', 'Tour 2027', 'stone'], ['Dornoch', 'Lads 2026', 'navy'],
      ['Crans-Montana', 'Stag 2027', 'stone'], ['Ballybunion', 'Society 2027', 'navy'],
      ['Belek', 'Winter Tour', 'stone'], ['St Andrews', 'Old Boys 2027', 'navy']
    ];
    var cycleIdx = 0, typed = false;
    function coordsFor(place) {
      var hit = window.FF_PLACES && window.FF_PLACES[place.toLowerCase()];
      return hit && window.FF_fmt ? window.FF_fmt(hit[0], hit[1]) : '';
    }
    function setTrip(place, trip, colour) {
      state.place = place; state.trip = trip; state.coords = coordsFor(place);
      if (colour) state.colour = colour;
      refresh();
    }

    if (mode === 'hero') {
      var input = root.querySelector('[data-kitroom-input]');
      if (input) input.addEventListener('input', function () {
        var v = input.value.trim();
        typed = !!v;
        if (v) setTrip(v.length > 18 ? v.slice(0, 18) : v, 'Tour ' + (new Date().getFullYear() + 1));
      });
      setInterval(function () {
        if (typed || !visible || document.hidden || reduceMotion) return;
        cycleIdx = (cycleIdx + 1) % CYCLE.length;
        var c = CYCLE[cycleIdx];
        root.classList.add('is-swapping');
        setTimeout(function () { setTrip(c[0], c[1], c[2]); root.classList.remove('is-swapping'); }, 260);
      }, 4200);
      root.querySelectorAll('[data-kitroom-colour]').forEach(function (b) {
        b.addEventListener('click', function () { state.colour = b.getAttribute('data-kitroom-colour'); refresh(); });
      });
    } else {
      document.querySelectorAll('[data-crest-input]').forEach(function (el) {
        var h = function () { setTimeout(readForm, 0); };
        el.addEventListener('input', h); el.addEventListener('change', h);
      });
      root.querySelectorAll('[data-kitroom-colour]').forEach(function (b) {
        b.addEventListener('click', function () {
          var want = b.getAttribute('data-kitroom-colour');
          var sel = document.querySelector('[data-crest-input="colour"]');
          if (sel) {
            for (var i = 0; i < sel.options.length; i++) if (/^navy/i.test(sel.options[i].value) === (want === 'navy')) sel.selectedIndex = i;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          } else { state.colour = want; refresh(); }
        });
      });
    }

    /* size */
    function resize() {
      var w = stage.clientWidth, h = stage.clientHeight;
      renderer.setSize(w, h, false); camera.aspect = w / h;
      camera.fov = w < 640 ? 42 : 32;
      camera.updateProjectionMatrix();
    }
    window.addEventListener('resize', function () { resize(); goal = VIEWS[view](); });

    /* loop, only while on screen */
    var visible = true, running = false, ready = false, lastT = 0;
    function kick() { if (ready && !running) { running = true; lastT = 0; requestAnimationFrame(tick); } }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) kick(); }).observe(stage);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
    var tmp = new T.Vector3();
    function tick(t) {
      if (!visible || document.hidden) { running = false; return; }
      var dt = lastT ? Math.min(t - lastT, 100) : 16; lastT = t;
      var k = reduceMotion ? 1 : 1 - Math.exp(-dt / 230);
      cam.target.lerp(goal.target, k);
      cam.dist += (goal.dist - cam.dist) * k;
      cam.elev += (goal.elev - cam.elev) * k;
      var idle = (t - lastInteract) > 5000 && !reduceMotion;
      if (idle) drag += ((view === 'fourball' ? Math.sin(t * 0.00025) * (mode === 'hero' ? 0.14 : 0.35) : Math.sin(t * 0.0004) * 0.2) - drag) * 0.02;
      var az = goal.az + drag;
      cam.az += (az - cam.az) * (reduceMotion ? 1 : 1 - Math.exp(-dt / 120));
      tmp.set(Math.sin(cam.az) * Math.cos(cam.elev), Math.sin(cam.elev), Math.cos(cam.az) * Math.cos(cam.elev)).multiplyScalar(cam.dist).add(cam.target);
      camera.position.copy(tmp); camera.lookAt(cam.target);

      if (!reduceMotion) golfers.forEach(function (g) {
        var u = g.userData, b = Math.sin(t * 0.0016 + u.phase);
        u.torso.scale.y = 1 + b * 0.008;
        g.rotation.z = Math.sin(t * 0.0007 + u.phase) * 0.008;
      });
      renderer.render(scene, camera);
      requestAnimationFrame(tick);
    }

    var go = function () {
      resize();
      if (mode === 'hero') setTrip(CYCLE[0][0], CYCLE[0][1], CYCLE[0][2]); else readForm();
      setView('fourball');
      cam = { target: goal.target.clone(), dist: goal.dist + 1.2, elev: goal.elev + 0.12, az: goal.az - 0.5 };
      if (loading) loading.hidden = true;
      root.classList.add('is-ready');
      ready = true; kick();
    };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go); else go();
  }
})();
